import { Component, OnInit, Input} from '@angular/core';
import {MediaQueryService} from '../../common/media-query';
import {Hotel} from '../../api/model/hotel/hotel.model';

@Component({
  selector: 'stay-mgmt-hotel-image',
  templateUrl: './hotel-image.component.html',
  styleUrls: ['./hotel-image.component.scss']
})
export class HotelImageComponent implements OnInit {
  hotelImageUrl;

  constructor(private mediaQueryService: MediaQueryService) { }
  ngOnInit() {

  }
  @Input()
  set hotel(hotel: Hotel) {
    if (hotel) {
      const parameterizedHotelImageUrl = this.appendImageParameters(hotel);
      if (parameterizedHotelImageUrl) {
        this.hotelImageUrl = this.sanitizeUrl(parameterizedHotelImageUrl);
      }
    }
  }

  appendImageParameters(hotel: Hotel) {
    const hotelPhoto = hotel.getAspectImage('2', '1');
    const defaultImage = hotel.getAspectImage('4', '3');
    const hotelPhotoUrl = (hotelPhoto.url !== '') ? hotelPhoto.url : defaultImage.url;

    let photoWidth = 640;
    if (this.mediaQueryService.photoWidth()) {
      photoWidth = this.mediaQueryService.photoWidth();
    }

    return hotelPhotoUrl ? hotelPhotoUrl + '?wid=' + photoWidth + '&fit=constrain' : undefined;
  }

  sanitizeUrl(urlIn: string) {
    let url = urlIn.toLowerCase().toString();
    if (url.substring(0, 5) === 'http:') {
      url = url.slice(4);
      url = 'https' + url;
    }
    return encodeURI(url);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/hotel-image/hotel-image.component.ts